<template>
    <div>
        远程操作
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>